export enum ExceptionAlertStatus {
  New = 'New',
  Pending = 'Pending',
  Expired = 'Expired',
}
